import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

/** Ilustraciones vectoriales para la página Acerca de TNO Network. */
export function AboutReachIllustration({ width = 120, color = '#ffffff' }) {
  const h = width * 0.82;
  const c = color;
  const soft = `${color}55`;
  return (
    <Box component="span" sx={{ display: 'block', lineHeight: 0 }}>
      <svg width={width} height={h} viewBox="0 0 120 98" fill="none">
        <circle cx="60" cy="48" r="32" stroke={c} strokeWidth="2.5" fill={soft} fillOpacity="0.15" />
        <ellipse cx="60" cy="48" rx="32" ry="12" stroke={c} strokeWidth="2" opacity="0.5" />
        <path d="M28 48c0-18 14-32 32-32s32 14 32 32" stroke={c} strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        <circle cx="28" cy="36" r="6" fill={c} opacity="0.45" />
        <circle cx="92" cy="58" r="5" fill={c} opacity="0.35" />
        <path d="M44 72h32" stroke={c} strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    </Box>
  );
}

AboutReachIllustration.propTypes = {
  width: PropTypes.number,
  color: PropTypes.string,
};

export function AboutEcosystemIllustration({ width = 120, color = '#ffffff' }) {
  const h = width * 0.85;
  const c = color;
  const soft = `${color}55`;
  return (
    <Box component="span" sx={{ display: 'block', lineHeight: 0 }}>
      <svg width={width} height={h} viewBox="0 0 120 102" fill="none">
        <rect x="14" y="22" width="44" height="32" rx="6" stroke={c} strokeWidth="2.5" fill={soft} fillOpacity="0.15" />
        <rect x="62" y="14" width="44" height="32" rx="6" stroke={c} strokeWidth="2.5" fill={soft} fillOpacity="0.2" />
        <rect x="38" y="56" width="44" height="32" rx="6" stroke={c} strokeWidth="2.5" fill={soft} fillOpacity="0.12" />
        <path d="M58 38h4M58 50v8M70 30l8-6M52 62l-8 8" stroke={c} strokeWidth="2" strokeLinecap="round" opacity="0.65" />
        <circle cx="96" cy="78" r="10" stroke={c} strokeWidth="2" fill={soft} fillOpacity="0.25" />
        <path d="M92 78h8M96 74v8" stroke={c} strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </Box>
  );
}

AboutEcosystemIllustration.propTypes = {
  width: PropTypes.number,
  color: PropTypes.string,
};

export function AboutCommunityIllustration({ width = 120, color = '#ffffff' }) {
  const h = width * 0.82;
  const c = color;
  const soft = `${color}55`;
  return (
    <Box component="span" sx={{ display: 'block', lineHeight: 0 }}>
      <svg width={width} height={h} viewBox="0 0 120 98" fill="none">
        <circle cx="44" cy="40" r="14" stroke={c} strokeWidth="2.5" fill={soft} fillOpacity="0.2" />
        <circle cx="76" cy="40" r="14" stroke={c} strokeWidth="2.5" fill={soft} fillOpacity="0.2" />
        <path d="M24 72c0-12 9-20 20-20s20 8 20 20M56 72c0-12 9-20 20-20s20 8 20 20" stroke={c} strokeWidth="2.5" fill="none" />
        <path d="M52 52c8-6 20-6 28 0" stroke={c} strokeWidth="2" strokeLinecap="round" opacity="0.75" />
        <circle cx="60" cy="28" r="8" fill={c} opacity="0.5" />
      </svg>
    </Box>
  );
}

AboutCommunityIllustration.propTypes = {
  width: PropTypes.number,
  color: PropTypes.string,
};

const ILLUSTRATION_MAP = {
  reach: AboutReachIllustration,
  ecosystem: AboutEcosystemIllustration,
  community: AboutCommunityIllustration,
};

export function AboutPillarIllustration({ type, width = 96, color = '#ffffff' }) {
  const Component = ILLUSTRATION_MAP[type] || AboutEcosystemIllustration;
  return <Component width={width} color={color} />;
}

AboutPillarIllustration.propTypes = {
  type: PropTypes.string,
  width: PropTypes.number,
  color: PropTypes.string,
};
